module.exports = __webpack_public_path__ + "img/support.9d162dbf.svg";